import { stack as d3_stack } from 'd3-shape'
import { extent as d3_extent, max as d3_max, min as d3_min } from 'd3-array'
import { convertRowsToData } from '../utils/dataUtils'

export default function BarChartDataController(rows, config = {}) {
  let headers = rows[0]
  let propperHeaders
  let dims
  if (config.mode === 'stacked') {
    propperHeaders = ['id', ...headers.slice(1)]
    dims = 2
  } else if (config.mode === 'grouped') {
    propperHeaders = ['id', ...headers.slice(1)]
    dims = 2
  } else {
    propperHeaders = ['id', 'value']
    dims = 1
  }
  let data = convertRowsToData([propperHeaders, ...rows.slice(1)], dims)

  //Sort data by mode
  if (config.dataSorting !== 'none') {
    if (config.mode === 'stacked') {
      data.sort((a, b) => {
        let aAddition = a.value.reduce((accumulator, current) => (accumulator += current.value), 0)
        let bAddition = b.value.reduce((accumulator, current) => (accumulator += current.value), 0)
        let diff = aAddition - bAddition
        return config.dataSorting === 'asc' ? diff : -diff
      })
    } else {
      data.sort((a, b) => {
        let diff = a.value - b.value
        return config.dataSorting === 'asc' ? diff : -diff
      })
    }
  }

  let extent
  if (config.mode === 'stacked') {
    extent = [
      d3_min(data, d => d3_min(d.value, dd => dd.value)),
      d3_max(data, d => d3_max(d.value, dd => dd.value)),
    ]
  } else if (config.mode === 'grouped') {
    extent = [
      d3_min(data, d => d3_min(d.value, dd => dd.value)),
      d3_max(data, d => d3_max(d.value, dd => dd.value)),
    ]
  } else {
    extent = d3_extent(data, d => d.value)
  }
  if (extent[0] > 0) extent[0] = 0
  let extentSize = Math.abs(extent[1] - extent[0])
  let getSafeValue = v => {
    return config.minBarHeight
      ? Math.sign(v || 1) * Math.max((extentSize * config.minBarHeight) / 100, Math.abs(v))
      : +v
  }

  if (config.mode === 'stacked') {
    let keys = data.reduce((res, d) => {
      d.value.forEach(dd => res.push(dd.id))
      return res
    }, [])
    keys = keys.filter((value, index, self) => self.indexOf(value) === index)

    let objArray = data.map(layer => {
      let res = { id: layer.id }
      layer.value.forEach(dd => {
        res[dd.id] = dd.value
      })
      return res
    })
    let stack = d3_stack()
      .value((d, key) => getSafeValue(d[key]))
      .keys(keys)

    let stacked = stack(objArray)
    let result = stacked.map(layer => {
      return {
        id: layer.key,
        index: layer.index,
        value: layer.map(dd => {
          return {
            id: dd.data.id,
            value: dd.data[layer.key],
            safeValue: getSafeValue(dd.data[layer.key]),
            y0: dd[0],
            y1: dd[1],
            layerIndex: layer.index,
            isLastLayer: keys.indexOf(layer.key) === keys.length - 1,
            isFirstLayer: keys.indexOf(layer.key) === 0,
            parentId: layer.key,
          }
        }),
      }
    })
    return result
  } else if (config.mode === 'grouped') {
    // return data.map((d,i)=>{
    //   if(!d.id) d.id = i
    //   return d
    // })
    let keys = data.reduce((res, d) => {
      d.value.forEach(dd => res.push(dd.id))
      return res
    }, [])
    keys = keys.filter((value, index, self) => self.indexOf(value) === index)

    let res = keys.map(key => {
      return {
        id: key,
        value: data.map(dd => {
          let cand = dd.value.find(ddd => ddd.id === key)
          return {
            id: cand.parentId,
            parentId: cand.id,
            value: cand.value,
            safeValue: getSafeValue(cand.value),
          }
        }),
      }
    })
    return res
  } else {
    return data.map((d, i) => {
      if (!d.id) d.id = i
      d.safeValue = getSafeValue(d.value)
      return d
    })
  }
}
